export const placeReduxConstants = {
  SET_HOVER: 'SET_HOVER',
  REMOVE_HOVER: 'REMOVE_HOVER',
  SET_PLACE_DATA: 'SET_PLACE_DATA',
};

export const PLACE_SUBSCRIPTION_TYPE = {
  STABLE: 'stable',
  ESSENTIAL: 'essential',
  GROWTH: 'growth',
  PROFILE_PAGE_PREMIUM: 'profilepagepremium',
  PROFILE_PAGE_VERIFIED: 'profilepageverified',
} as const;
